export var MPAReviewSubmitDecision;
(function (MPAReviewSubmitDecision) {
    MPAReviewSubmitDecision["MPA_REVIEW_SUBMIT_DECISION_APPROVED"] = "APPROVED";
    MPAReviewSubmitDecision["MPA_REVIEW_SUBMIT_DECISION_DENIED"] = "DENIED";
})(MPAReviewSubmitDecision || (MPAReviewSubmitDecision = {}));
